// ── nativeBridge — системные вещи Android-приложения (плагин AppBridge) ───────
// minimizeApp — «Назад» на главном экране сворачивает приложение, как у всех.
// openExternal — открыть адрес в браузере телефона (вход через Google: внутри
//   приложения Google вход не пускает).
// onDeepLink — приложение открыли ссылкой com.audiocards.app://… (возврат из браузера).
// Плагин есть в APK с версии 1.3.0; на старых версиях и на сайте функции молчат.
// Важно: прокси плагина нельзя возвращать из async-функций и ждать через await
// (у прокси «есть» then — вызов зависает), поэтому он лежит в модуле как есть.

import { registerPlugin } from '@capacitor/core';

const isNative = typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform?.();
const _plugin = isNative ? registerPlugin('AppBridge') : null;

export const hasAppBridge = () => isNative && !!window.Capacitor?.isPluginAvailable?.('AppBridge');

export function minimizeApp() {
  if (!hasAppBridge()) return false;
  _plugin.minimizeApp().catch(() => {});
  return true;
}

export function openExternal(url) {
  if (!hasAppBridge()) return Promise.reject(new Error('no AppBridge'));
  return _plugin.openExternal({ url });
}

export function onDeepLink(cb) {
  if (!hasAppBridge()) return () => {};
  const seen = new Set();
  const once = (url) => { if (url && !seen.has(url)) { seen.add(url); cb(url); } };
  let handle = null;
  _plugin.addListener('deepLink', (d) => once(d?.url)).then((h) => { handle = h; }).catch(() => {});
  _plugin.takeDeepLink().then((r) => once(r?.url)).catch(() => {});
  return () => { try { handle?.remove(); } catch {} };
}
